import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=b0ce1fba&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=b0ce1fba&prod&lang=less&scoped=true&"
import style1 from "../assets/pc-auth.less?vue&type=style&index=1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ce1fba",
  null
  
)

export default component.exports